<div class="casinolobbycontainer">
  <div class="box" *ngFor="let item of gameTypes" (click)="goGames(item)" [ngStyle]="{ 'background-image': 'url(' + item.imgUrl + ')' }">
    <span>{{ item.name }}</span>
  </div>
</div>
